import endpointUrls from 'global/Constants/endpointUrls';
import { queryKeys } from 'global/Constants/queryKeys';
import { useApiMutation } from 'query';

export function senderClientApi(onSuccess?: () => void) {
  const makeDefaultMutation = useApiMutation(endpointUrls.cienrSetDefaultSender, {
    method: 'post',
    invalidateKeys: [queryKeys.clients],
    successMessage: 'تغییر فرستنده پیشفرض با موفقیت انجام شد.',
    onSuccess: onSuccess,
  });

  const handleMakeDefault = (id: number, _isDefault = true) => {
    makeDefaultMutation.mutate({ clientId: id });
  };

  return {
    handleMakeDefault,
  };
}
